import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";
import { FIELD_COLORS, COMMON_STYLES, COLORS } from "../constants";
import {
  LoanEligibilityResponse,
  LoanOffer,
  StatusType,
} from "../types";
import LoanOffersView from "./LoanOffersView";

interface SelectedOfferViewProps {
  offerData?: LoanEligibilityResponse;
  status?: StatusType;
}

const SelectedOfferView: React.FC<SelectedOfferViewProps> = ({
  offerData,
  status = "",
}) => {
  const { labelColor, valueColor, valueBgColor } = FIELD_COLORS;

  // Use provided data or fall back to mock data for development
  const singleOffer: LoanOffer | null =
    Array.isArray(offerData?.offer) && offerData?.offer.length === 1
      ? offerData?.offer[0]
      : null;
  return (
    <div className="container mt-4">
      {status === "APPROVED" && singleOffer ? (
        <>
          <p
            className="text-dark m-0"
            style={{
              ...COMMON_STYLES.sectionTitle,
              color: COLORS.TEXT_PRIMARY,
            }}
          >
            Selected Offer
          </p>
          <hr />
          <div className="row">
            <ReadonlyField
              label="Offer interest"
              value={singleOffer?.interest ?? "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Offer Interest Rate"
              value={singleOffer?.interest_rate ?? "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Offer Amount"
              value={singleOffer?.loan_amount ?? "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Offer Product"
              value={singleOffer?.loan_product ?? "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="APR"
              value={singleOffer?.APR ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Monthly Installment"
              value={singleOffer?.Installments_list?.[0].PAYMENT ?? "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Requested amount"
              value={offerData?.requested_loan ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Tenure"
              value={singleOffer?.tenure ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Max Eligibility Amount"
              value={singleOffer?.Principal_max ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            <ReadonlyField
              label="Max Eligibility Installments"
              value={offerData?.max_rac_allowed_tenure ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
            {/* <ReadonlyField
          label="Eligible Amount Consent"
          value={singleOffer?.eligibleAmountConsent ?? ""}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Offer acceptance date"
          value={singleOffer?.offerAcceptanceDate ?? ""}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        /> 
            <ReadonlyField
              label="Offer Applied"
              value={singleOffer?.offerApplied ?? ""}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            /> 
             <ReadonlyField
              label="Offer Scheme ID"
              value={singleOffer?.offerSchemeId || "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />  */}
            <ReadonlyField
              label="Offer Package ID"
              value={singleOffer?.packageID || "-"}
              labelColor={labelColor}
              valueColor={valueColor}
              valueBgColor={valueBgColor}
            />
          </div>
        </>
      ) : (
        <LoanOffersView offers={offerData?.offer} />
      )}
    </div>
  );
};

export default memo(SelectedOfferView);
